import type { ReactNode } from 'react';

interface InactiveProgressModalConfig {
    state: 'inactive';
    title?: never;
    caption?: never;
    closeButtonLabel?: never;
    actions?: never;
    disableAutoClose?: never;
}

interface PendingProgressModalConfig {
    state: 'pending';
    title: string;
    caption?: string | ReactNode;
    closeButtonLabel?: never;
    actions?: Array<ReactNode>;
    disableAutoClose?: never;
}

interface FailedProgressModalConfig {
    state: 'failed';
    title: string;
    caption: string | ReactNode;
    closeButtonLabel?: string;
    actions?: Array<ReactNode>;
    disableAutoClose?: never;
}

interface SuccessProgressModalConfig {
    state: 'success';
    title: string;
    caption?: string | ReactNode;
    closeButtonLabel?: never;
    actions?: Array<ReactNode>;
    disableAutoClose?: boolean;
}

interface WarningProgressModalConfig {
    state: 'warning';
    title: string;
    caption: string | ReactNode;
    closeButtonLabel?: never;
    actions?: Array<ReactNode>;
    disableAutoClose?: never;
}

type ProgressModalConfig =
    | FailedProgressModalConfig
    | InactiveProgressModalConfig
    | PendingProgressModalConfig
    | SuccessProgressModalConfig
    | WarningProgressModalConfig;

const INACTIVE_PROGRESS_CONFIG: ProgressModalConfig = {
    state: 'inactive',
};

// Type for the actions that can be dispatched to the snackbar reducer
type ProgressReducerAction =
    | { type: 'close' }
    | { type: 'update'; payload: ProgressModalConfig };

const progressReducer = (
    state: ProgressModalConfig,
    action: ProgressReducerAction
): ProgressModalConfig => {
    switch (action.type) {
        case 'close':
            return INACTIVE_PROGRESS_CONFIG;
        case 'update':
            return action.payload;
        default:
            return state;
    }
};

export { INACTIVE_PROGRESS_CONFIG, progressReducer };
export type {
    FailedProgressModalConfig,
    InactiveProgressModalConfig,
    PendingProgressModalConfig,
    ProgressModalConfig,
    ProgressReducerAction,
    SuccessProgressModalConfig,
};
